import { useState } from 'react'
import './SearchBar.css'

function SearchBar({ value, onChange, onSearch, placeholder }) {
  const handleSubmit = (e) => {
    e.preventDefault()
    onSearch(value)
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      onSearch(value)
    }
  }

  return (
    <div className="search-bar-container">
      <form onSubmit={handleSubmit} className="search-form">
        <div className="search-input-wrapper">
          <svg
            className="search-icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
          >
            <circle cx="11" cy="11" r="8" strokeWidth="2"/>
            <path d="m21 21-4.35-4.35" strokeWidth="2"/>
          </svg>
          <input
            type="text"
            className="search-input"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder={placeholder}
          />
        </div>
        <button type="submit" className="search-button">
          Search
        </button>
      </form>
    </div>
  )
}

export default SearchBar
